import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function JoinGame() {
  const { joinCode } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [game, setGame] = useState(null);

  useEffect(() => {
    joinGame();
  }, [joinCode]);

  const joinGame = async () => {
    try {
      // Fetch game by join code
      const res = await fetch(`${window.API_URL}/api/games/active/join/${joinCode}`);

      if (!res.ok) {
        setError('Game not found or has already ended');
        setLoading(false);
        return;
      }

      const gameData = await res.json();
      setGame(gameData);

      // Add current user to the game if not already in
      const isInGame = gameData.players?.some(p => p.user_id === user.id);

      if (!isInGame) {
        await fetch(`${window.API_URL}/api/games/active/${gameData.id}/players`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: user.id })
        });
      }

      // Check if game is still in setup phase
      if (gameData.status === 'setup') {
        // Game still setting up, go to game-setup page with the active game ID
        navigate(`/game-setup/${gameData.slug}?activeGameId=${gameData.id}`, { replace: true });
        return;
      }

      // Game already started, go directly to game scoreboard
      navigate(`/game/${gameData.id}`, { replace: true });

    } catch (err) {
      console.error('Error joining game:', err);
      setError('Failed to join game');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center">
        <div className="text-center">
          <div className="text-4xl mb-4">🎮</div>
          <p className="text-white text-lg">Joining game...</p>
          <p className="text-slate-400 text-sm mt-2">Code: {joinCode}</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center p-4">
        <div className="bg-slate-800 rounded-xl p-6 max-w-sm w-full text-center">
          <div className="text-4xl mb-4">😕</div>
          <h1 className="text-xl font-bold text-white mb-2">Couldn't Join Game</h1>
          <p className="text-slate-400 mb-4">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-lg font-medium"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return null;
}
